import { createI18n } from 'vue-i18n';
import de from '../../../translations/messages+intl-icu.de.yaml';
import fr from '../../../translations/messages+intl-icu.fr.yaml';
import it from '../../../translations/messages+intl-icu.it.yaml';
import en from '../../../translations/messages+intl-icu.en.yaml';
import si from '../../../translations/messages+intl-icu.si.yaml';

const i18n = createI18n({
    locale: 'de',
    fallbackLocale: 'de',
    messages: {
        de,
        fr,
        it,
        en,
        si
    },
})

export default i18n;